import type { Camera } from "~/entities/camera/types";
import axiosInstance from "~/shared/api/axios-instance";

interface CameraResponse {
  id: number;
  pseudo_camera: {
    id: number;
    default_cam_id: string;
    branch_uid: string;
  };
  preview_img_url?: string;
  original_img_url?: string;
  analyzed_id: string | null;
  floor_plan_id: number | null;
  position: { x: number; y: number; rotation: number } | null;
  extra_camera_orientation_status: { extra_id: string } | null;
  adjustment_status: {
    adjustment_id: string;
    position: { x: number; y: number; rotation: number };
    frame: { dx: number; dy: number };
  } | null;
}

export const fetchCameras = async (
  branchUid: string,
  versionId?: number,
): Promise<Camera[]> => {
  const { data } = await axiosInstance.get<CameraResponse[]>(
    `branches/${branchUid}/pseudo-camera-orientations/`,
    { params: { version: versionId } },
  );

  return data.map((cam) => ({
    id: cam.id,
    pseudoCameraId: cam.pseudo_camera.id,
    defaultCamId: cam.pseudo_camera.default_cam_id,
    branchUid: cam.pseudo_camera.branch_uid,
    originalImageUrl: cam.original_img_url,
    previewImageUrl: cam.preview_img_url,
    analysisNumber: cam.analyzed_id ?? null,
    floorPlanId: cam.floor_plan_id ?? null,
    position: cam.position ?? null,
    mappingType: cam.extra_camera_orientation_status
      ? "add"
      : cam.adjustment_status
        ? "edit"
        : "default",
    additionId: cam.extra_camera_orientation_status?.extra_id ?? null,
    adjustmentId: cam.adjustment_status?.adjustment_id ?? null,
    adjustmentPosition: cam.adjustment_status
      ? {
          x: cam.adjustment_status.position.x,
          y: cam.adjustment_status.position.y,
          rotation: cam.adjustment_status.position.rotation,
        }
      : null,
    adjustmentFrame: cam.adjustment_status
      ? {
          dx: cam.adjustment_status.frame.dx,
          dy: cam.adjustment_status.frame.dy,
        }
      : null,
  }));
};
